<template>
  <div class="center-cmp box box_v">
    <dv-border-box-9>

      <div class="cc-header">
        <dv-decoration-1 class="xian"/>
        用券消费总额
        <dv-decoration-1 class="xianright"/>
      </div>

      <div class="cc-details box">

        <div style="font-size: 55px">￥</div>
        <div class="carddiv" v-for="num in getCardNum(parseInt(parseFloat(supermarket.goodsAmount) + parseFloat(hypermarket.goodsAmount)))">
          <div v-if="num!=','" class="card">{{num}}</div>
          <div v-else>,</div>
        </div>
      </div>

      <div class="cc-bottom box box_center">
        <table>
          <tr>
            <td><div class="title">超市券：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">{{toThousands(supermarket.num, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">{{toThousands(supermarket.writenum, true)}}</div></td>
            <td><div class="title-ff">消费</div></td>
            <td><div class="title-num">{{toThousands(supermarket.goodsAmount, true)}}元</div></td>
          </tr>
          <tr>
            <td><div class="title">商场券：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">{{toThousands(hypermarket.num, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">{{toThousands(hypermarket.writenum, true)}}</div></td>
            <td><div class="title-ff">消费</div></td>
            <td><div class="title-num">{{toThousands(hypermarket.goodsAmount, true)}}元</div></td>
           </tr>

          <tr>
            <td><div class="title">合计：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">{{toThousands(parseInt(supermarket.num) + parseInt(hypermarket.num), true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">{{toThousands(parseInt(supermarket.writenum) + parseInt(hypermarket.writenum), true)}}</div></td>
            <td><div class="title-ff">消费</div></td>
            <td><div class="title-num">{{toThousands(parseFloat(supermarket.goodsAmount) + parseFloat(hypermarket.goodsAmount), true)}}元</div></td>
          </tr>

        </table>
      </div>
    </dv-border-box-9>


  </div>
</template>

<script>
  export default {
      name: "centerCmp",
      computed: {
        xiaofeiquanVue() {
          return this.$store.state.xiaofeiquanVue
        },
      },
      created() {
        this.load()

        //this.getConsumeSum()
        // this.supermarket()
        // this.hypermarket()
        // this.lqSum()
      },
      data() {
        return {
          supermarket: {
            discountCouponType: "超市",
            goodsAmount: 0,
            writenum: 0,
            num: 0
          },
          hypermarket: {
            discountCouponType: "商场",
            goodsAmount: 0,
            writenum: 0,
            num: 0
          },

          consumeSum: 0
        }
      },
      methods: {
        load() {
          //GET api/coupon-count/countWrite
          //累计核销张数、消费金额
          this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/countWrite', {},request=> {
            request.rows.forEach(item=> {
              if(item.discountCouponType=="超市") {
                this.supermarket.goodsAmount = item.goodsAmount?item.goodsAmount:0
                this.supermarket.writenum = item.writenum?item.writenum:0
              }else if(item.discountCouponType=="商场") {
                this.hypermarket.goodsAmount = item.goodsAmount?item.goodsAmount:0
                this.hypermarket.writenum = item.writenum?item.writenum:0
              }
            })
          })
          //GET api/coupon-count/countSheet
          //超市、商场领取券张数统计
          this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/countSheet', {},request=> {
            request.rows.forEach(item=> {
              if(item.companyName=="超市") {
                this.supermarket.num = item.num?item.num:0
              }else if(item.companyName=="商场") {
                this.hypermarket.num = item.num?item.num:0
              }
            })
          })
        },
        setData() {

        },
        getConsumeSum() {
          //拉动消费总额
          this.xiaofeiquanVue.loopAxios({
            sign: 8,
          },request=> {
            if(request.rows[0] && request.rows[0].consumeSum) {
              this.consumeSum = parseInt(request.rows[0].consumeSum)
            }
          })
        },
        getCardNum(num) {
          return this.toThousands(num)
          //return this.toThousands(this.consumeSum)
        },
        toThousands(_num, bol) {
          _num = _num.toFixed(4)*1
          let numArr = (_num+'').split('.')
          let num = parseInt(numArr[0])
          let xs = numArr[1]?numArr[1]:''

          let result = [ ], counter = 0;
          num = (num || 0).toString().split('')
          for (let i = num.length - 1; i >= 0; i--) {
            counter++
            result.unshift(num[i])
            if (!(counter % 3) && i != 0) { result.unshift(','); }
          }
          if(xs) {
            result = [...result, '.', ...xs.split('')]
          }
          if(bol) {
            return result.join('')
          }else {
            return result
          }
        }
      },
  }
</script>

<style lang="less">
  .center-cmp {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;

    .cc-header {
      height: 30px;
      text-align: center;
      font-size: 20px;
      position: relative;

      .xian {
        width: 150px;
        height: 30px;
        top: 0;
        left: 20px;
        position: absolute;
      }
      .xianright {
        width: 150px;
        height: 30px;
        top: 0;
        right: 0px;
        position: absolute;
      }
    }
    .cc-details {
      height: 120px;
      justify-content: center;
      font-size: 32px;
      align-items: center;
      .carddiv {

        .card {
          background-color: rgba(4,49,128,.6);
          color: #08e5ff;
          height: 70px;
          width: 45px;
          font-size: 58px;
          font-weight: bold;
          line-height: 70px;
          text-align: center;
          margin: 5px;
        }
      }

    }

    .cc-bottom {
      height: 120px;
      font-size: 18px;
      box-sizing: border-box;

      .title {
        color: rgb(85, 198, 255);
        padding: 4px 10px 4px 0;
      }
      .title-ff {
        font-size: 15px;
      }
      .title-num {
        color: rgb(255, 252, 134);
        padding-right: 10px;
        font-size: 18px;
      }
    }
  }
</style>
